import { Grid, Link, Typography } from "@mui/material";
import { ContainedButton } from "./styled/contained-button";
import { FooterLink } from "./styled/footer-link";
import { useContext } from "react";
import { UserProgramContext } from "../context/user-program/user-program";

export const Footer = () => {
  const { userPayload } = useContext(UserProgramContext);

  const { role } = userPayload as {
    _id: string;
    firstName: string;
    lastName: string;
    role: string;
  };

  const showFooter =
    role !== "employee" &&
    role !== "admin" &&
    role !== "clinic-weight" &&
    role !== "clinic-dashboard";

  return showFooter ? (
    <Grid
      flexDirection={{ xs: "column", md: "row" }}
      rowGap={{ xs: "1rem", md: 0 }}
      alignContent={{ xs: "center", md: "flex-start" }}
      container
      flexWrap="nowrap"
      justifyContent="space-around"
      sx={{
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        padding: "1rem",
      }}
    >
      <Grid item>
        <Typography variant="h5" mb={2}>
          Impressum & Datenschutz
        </Typography>
        <FooterLink href="https://www.adipositasgutachten.de/impressum">
          <Typography variant="body2">Impressum</Typography>
        </FooterLink>
        <FooterLink href="https://www.adipositasgutachten.de/datenschutz">
          <Typography variant="body2">Datenschutzerklärung</Typography>
        </FooterLink>
        <FooterLink href="https://www.adipositasgutachten.de/allgemeine-geschaeftsbedingungen">
          <Typography variant="body2">
            Allgemeine Geschäftsbedingungen
          </Typography>
        </FooterLink>
        <FooterLink href="https://www.adipositasgutachten.de/informationen-zum-gesundheitsdatenschutz">
          <Typography variant="body2">
            Informationen zum Gesundheitsdatenschutz
          </Typography>
        </FooterLink>
      </Grid>
      <Grid item>
        <Typography variant="h5" mb={2}>
          Kontakt
        </Typography>
        <Link href="https://www.adipositasgutachten.de/kontakt" target="_blank">
          <ContainedButton>Kontakt aufnehmen</ContainedButton>
        </Link>
      </Grid>
    </Grid>
  ) : null;
};
